import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { Typography, Box } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useTheme } from '@mui/material/styles';
import BottomSheetOrDialog from '../../components/BottomSheetOrDialog/BottomSheetOrDialog';
import { tracking } from '../../utils/tracking';
import { withRouter } from 'react-router-dom';
import SurveyButton, { surveyConfig } from '../SurveyButton';
import { connect } from 'react-redux';
import { getIsChubbUser } from '../../utils/user';
import { Fragment } from 'react';

const SupportBottomSheet = ({ intl, open, onClose, openChatBot, history, userDetails }) => {
  const theme = useTheme();

  const closeAndOpenChatBot = () => {
    onClose();
    openChatBot();
  };

  const isChubbUser = getIsChubbUser();

  return (
    <BottomSheetOrDialog
      open={open}
      onClose={onClose}
      header={intl.formatMessage({ id: 'contact-support-team' })}
      content={
        <>
          {!isChubbUser && (
            <Fragment>
              <Box
                onClick={() => {
                  history.push('/reservation');
                  tracking('Click on Support Bottom Sheet- SupportFab', {
                    Label: intl.formatMessage({ id: 'schedule-one-on-on-consultation' }),
                    Target: '/reservation'
                  });
                }}
                style={{
                  borderRadius: 16,
                  padding: 16,
                  background: theme.palette.primary.main,
                  cursor: 'pointer'
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <WhatsAppIcon style={{ color: 'white', marginRight: 8, fontSize: 24 }} />
                <Typography
                  style={{ fontSize: intl.locale === 'en' ? 17 : 20, fontWeight: 500, color: 'white', marginLeft: 8 }}
                >
                  {/* {intl.formatMessage({ id: 'business-idea-chatbot' })} */}
                  {intl.formatMessage({ id: 'schedule-one-on-on-consultation' })}
                </Typography>
              </Box>

              <Box
                style={{ margin: 12 }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography style={{ fontSize: 24, fontWeight: 600 }}>
                  {' '}
                  {intl.formatMessage({ id: '-or-' })}{' '}
                </Typography>
              </Box>
            </Fragment>
          )}

          <Box>
            <Box
              onClick={closeAndOpenChatBot}
              style={{
                borderRadius: 16,
                marginTop: 12,
                marginBottom: 12,
                padding: 16,
                border: '1px solid black'
              }}
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <img alt="A.I. Pro" src="img/icons/ai_bg_free.svg" width={28} height={28} />
              <Typography style={{ marginLeft: 16, fontSize: 20, fontWeight: 500 }}>
                {intl.formatMessage({ id: 'business-idea-chatbot' })}
              </Typography>{' '}
            </Box>

            {['whatsapp-support', 'book-morning-sharing-session'].map(item => (
              <Box
                key={item}
                onClick={() => {
                  window.open(
                    `https://api.whatsapp.com/send?phone=85266370320&text=(APP) ${encodeURIComponent(
                      intl.formatMessage({ id: item }) + '\n'
                    )}`,
                    '_blank'
                  );
                  // history.push('/reservation');
                  tracking('Click on Support Bottom Sheet- SupportFab', {
                    Label: intl.formatMessage({ id: item }),
                    // Target: `https://api.whatsapp.com/send?phone=85266370320&text=(APP) ${encodeURIComponent(
                    //   intl.formatMessage({ id: item }) + '\n'
                    // )}`
                    Target: '/reservation'
                  });
                }}
                style={{
                  borderRadius: 16,
                  marginTop: 12,
                  marginBottom: 12,
                  padding: 16,
                  border: '1px solid black'
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <WhatsAppIcon color="primary" style={{ marginRight: 16, fontSize: 32 }} />
                <Typography style={{ fontSize: 20, fontWeight: 500 }}>{intl.formatMessage({ id: item })}</Typography>
              </Box>
            ))}
            <Box style={{ textAlign: 'center' }}>
              <SurveyButton data={{ email: userDetails.email }} config={surveyConfig} />
            </Box>
          </Box>
        </>
      }
      actions={[]}
      BottomSheetProps={{
        expandOnContentDrag: false,
        disableAutoDismiss: true
      }}
    />
  );
};

const container = connect(state => ({
  userDetails: state.user.userDetails
}))(SupportBottomSheet);

export default injectIntl(withRouter(container));
